


















import {Component, Vue, Prop} from 'vue-property-decorator'
import getImageSource from "@/helpers/getImageSource.ts";

@Component
export default class RankingColumn extends Vue {
  @Prop({required: true}) rankingList!: object[]
  @Prop({required: true}) type!: string

  public TypeName = {
    total: '总排行',
    month: '月排行',
    wish: '星愿排行'
  }

  public getImageSource(size: string, path: string){
    return getImageSource(size, path)
  }

}
